var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateoven(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9286 8.57143H8.57143V13.9286C8.57143 14.5179 8.08929 15 7.5 15C6.91071 15 6.42857 14.5179 6.42857 13.9286V8.57143H1.07143C0.482143 8.57143 0 8.08929 0 7.5C0 6.91071 0.482143 6.42857 1.07143 6.42857H6.42857V1.07143C6.42857 0.482143 6.91071 0 7.5 0C8.08929 0 8.57143 0.482143 8.57143 1.07143V6.42857H13.9286C14.5179 6.42857 15 6.91071 15 7.5C15 8.08929 14.5179 8.57143 13.9286 8.57143Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.645833,
    y1: -5.48319,
    x2: 15.6247,
    y2: -5.34177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122751,
    stopColor: "#0F62FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5BD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateoven);
export default __webpack_public_path__ + "static/media/createoven.d234dc983b78d29900e6e31f72a53aac.svg";
export { ForwardRef as ReactComponent };